import React from "react";
import { FaAngleDoubleLeft, FaAngleLeft, FaAngleRight, FaAngleDoubleRight } from "react-icons/fa";

export default function Pagination({ currentPage, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const goTo = (page) => {
    if (page >= 1 && page <= totalPages) onPageChange(page);
  };

  const getPages = () => {
    const delta = 1;
    const range = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) range.unshift("...");
    if (currentPage + delta < totalPages - 1) range.push("...");

    range.unshift(1);
    if (totalPages !== 1) range.push(totalPages);

    return range;
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      
      {/* First */}
      <button
        disabled={currentPage === 1}
        onClick={() => goTo(1)}
        style={btnStyle}
      >
        <FaAngleDoubleLeft />
      </button>

      {/* Prev */}
      <button
        disabled={currentPage === 1}
        onClick={() => goTo(currentPage - 1)}
        style={btnStyle}
      >
        <FaAngleLeft />
      </button>

      {/* Pages */}
      {getPages().map((p, i) =>
        p === "..." ? (
          <span key={i} style={{ padding: "0 4px" }}>...</span>
        ) : (
          <button
            key={i}
            onClick={() => goTo(p)}
            style={{
              ...btnStyle,
              backgroundColor: p === currentPage ? "#3b82f6" : "#f3f4f6",
              color: p === currentPage ? "#fff" : "#000",
              fontWeight: p === currentPage ? "600" : "400",
            }}
          >
            {p}
          </button>
        )
      )}

      {/* Next */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => goTo(currentPage + 1)}
        style={btnStyle}
      >
        <FaAngleRight />
      </button>

      {/* Last */}
      <button
        disabled={currentPage === totalPages}
        onClick={() => goTo(totalPages)}
        style={btnStyle}
      >
        <FaAngleDoubleRight />
      </button>
    </div>
  );
}

const btnStyle = {
  padding: "4px 6px",
  fontSize: "12px",
  border: "1px solid #ddd",
  borderRadius: "4px",
  background: "#fff",
  cursor: "pointer"
};